export const CurrentEventsJournaling = {
  title: 'Current Events Journaling',
  icon: '/static/templates_icons/CurrentEventsJournaling.svg',
  prompt: `
    <p class="pink-selectable">
      [Learn more about how to implement this activity in your classroom at
      <a target="_blank" href="https://parlayideas.com/templates/#news-journal">https://parlayideas.com/templates/#news-journal</a>]
    </p>
    <h3>Introduction</h3>
    <p>
      The <span class="pink-selectable">[theme/topic]</span> we are currently exploring is <span class="pink-selectable">[name of theme/topic]</span>. This discussion is a
      journaling exercise for us explore this theme in more detail as individuals first and then as a group.
    </p>
    <h3>Part 1 - Personal Submission</h3>
    <p>
      Find a news article or other online resource (video, photo, etc.) that relates to this topic/theme.
      Complete the following steps in <span class="pink-selectable">two</span> or more paragraphs in your personal submission:
    </p>
    <p><strong>
      &nbsp;&nbsp; 1. Share a link to the resource (or embed the video / image as appropriate). <br>
      &nbsp;&nbsp; 2. Summarize the main ideas of the event. <br>
      &nbsp;&nbsp; 3. Explain how it relates to the <span class="pink-selectable">[theme/topic]</span>. <br>
      &nbsp;&nbsp; 4. Provide your own opinion on the article.
    </strong></p>
    <h3>Part 2 - Peer Feedback and Discussion</h3>
    <p>
      After you've submitted your response, comment on at least <span class="pink-selectable">two</span> of your peers' submissions,
      answering the guided feedback questions provided. Try your best to comment on submissions
      that don’t yet have any feedback, and don’t forget to reply to any comments on your own
      submission.
    </p>
  `,
};



// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Defaults/CurrentEventsJournaling.js